import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddPlusIcon from '../assets/images_/Add_Plus.svg';

interface PageHeaderProps {
  breadcrumb: React.ReactNode;
  title: string;
  searchPlaceholder?: string;
  addNewLabel?: string;
  onAddNew?: () => void;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  breadcrumb,
  title,
  searchPlaceholder = 'Search',
  addNewLabel = 'Add New',
  onAddNew,
  onSearchChange,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    if (onSearchChange) onSearchChange(e);
  };

  const handleClear = () => {
    setSearchValue('');
    if (onSearchChange) onSearchChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
  };

  const handleAddNew = () => {
    if (onAddNew) {
      onAddNew();
    } else {
      navigate('/WeeklyReports/detail');
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>{breadcrumb}</div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
        padding: 24,
        borderRadius: 8,
        marginBottom: 24
      }}>
        <h1 style={{ fontWeight: 600, fontSize: 24, margin: 0 , lineHeight: 1.2}}>{title}</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {onSearchChange && (
            <form className="app-search" style={{ margin: 0, height: 'auto' }}>
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={searchPlaceholder}
                  value={searchValue}
                  onChange={handleInputChange}
                  style={{ minWidth: 200 }}
                />
                <span className="mdi mdi-magnify search-widget-icon" style={{ position: 'absolute', left: 13, top: 0, fontSize: 18, lineHeight: '38px', color: '#888', height: '100%', display: 'flex', alignItems: 'center' }}></span>
                {searchValue && (
                  <span
                    className="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                    style={{ position: 'absolute', right: 7, top: 0, fontSize: 18, lineHeight: '38px', color: '#888', height: '100%', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={handleClear}
                  ></span>
                )}
              </div>
            </form>
          )}
          {onAddNew && (
            <button
              onClick={handleAddNew}
              style={{
                fontFamily: 'Inter, Helvetica Neue, Arial, sans-serif',
                fontWeight: 500,
                fontSize: '13px',
                lineHeight: '150%',
                letterSpacing: '0%',
                textAlign: 'center',
                minWidth: '107px',
                height: '36px',
                borderRadius: '10px',
                gap: '4px',
                paddingTop: '8px',
                paddingRight: '16px',
                paddingBottom: '8px',
                paddingLeft: '16px',
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                transition: 'background 0.2s',
                whiteSpace: 'nowrap',
              }}
            >
              <img src={AddPlusIcon} alt="Add" style={{ width: 20, height: 20, marginRight: 4, display: 'inline-block', verticalAlign: 'middle' }} />
              {addNewLabel.replace(/^\+/, '').trim()}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader; 